import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Layout from "@/components/feature/Layout";
import Home from "@/pages/home/page";
import Collections from "@/pages/collections/page";
import GuaDetail from "@/pages/gua/page";
import About from "@/pages/about/page";
import Contact from "@/pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "heji",
        element: <Collections />,
      },
      {
        path: "gua/:id",
        element: <GuaDetail />,
      },
      {
        path: "about",
        element: <About />,
      },
      {
        path: "contact",
        element: <Contact />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;